import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import PropTypes from 'prop-types';

const PRODUCT_KEY_FILTER_SOME = 'some';
const PRODUCT_KEY_FILTER_EVERY = 'every';

const FeatureTogglingRender = ({ children, flags, notAllowedProductKey, productKeyFilter }) => {
    const keyValue = [PRODUCT_KEY_FILTER_SOME, PRODUCT_KEY_FILTER_EVERY];

    if (typeof notAllowedProductKey === 'string' || notAllowedProductKey instanceof String) {
        return !!flags?.get(notAllowedProductKey) && children;
    }
    if (Array.isArray(notAllowedProductKey)) {
        if (keyValue.some(key => productKeyFilter === key)) {
            return notAllowedProductKey[productKeyFilter](flag => !!flags?.get(flag)) && children;
        }
        throw new Error(
            "If 'productKeyFilter' is an array, you should specify 'every' or 'some' to set the type of filter."
        );
    } else if (typeof notAllowedProductKey === 'function') {
        return notAllowedProductKey(flags) && children;
    } else if (typeof notAllowedProductKey === Boolean) {
        return notAllowedProductKey && children;
    }

    return null;
};

FeatureTogglingRender.propTypes = {
    children: PropTypes.node.isRequired,
    flags: PropTypes.object.isRequired,
    notAllowedProductKey: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.func, PropTypes.bool])
        .isRequired,
    productKeyFilter: PropTypes.string,
};

export default withFeatureToggling(FeatureTogglingRender);
